export default "__VITE_ASSET__f071115a__"